import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import isEqual from 'lodash/isEqual';

import { FiltersListButtons, ButtonIcon } from '../Elements.js';
import InputWithEnter from '../../forms/InputWithEnter/InputWithEnter';

import { delProperties } from 'utils/common';
import { postRequest } from 'utils/requests';
import { showNotif } from 'utils/notification';
import { listChangedNameFilers } from 'data/listChangedNameFilers';

import classes from './SaveFilterBlock.module.scss';

const SaveFilterBlock = ({
  visibleFilterSave,
  setVisibleFilterSave,
  visibleFilterEdit,
  setVisibleFilterEdit,
  filterBackend,
  setFilter,
  changeFilter,
  setChangeFilter,
  setFilterBackend,
  resetAllfilters,
  filter,
  defaultNavigation,
  setTrigerResetDatePicker,
  trigerResetDatePicker,
  setStartFilter,
  startFilter,
  defaultFilters,
  tableConf,
  setTableConf,
  defaulTableConf,
  triggerSaveTableSettings,
  setFilterButton
}) => {
  const [triggerStartEffect, setTriggerStartEffect] = useState(false);

  const { t } = useTranslation(['activity']);

  useEffect(() => {
    let cancelled = false;

    const REQ_BODY = {
      key: filterBackend.key
    };

    postRequest('/user/storage/read', REQ_BODY)
      .then(res => {
        if (!cancelled) {
          if (res.body) {
            setFilterBackend({
              ...filterBackend,
              value: res.body
            });
          } else {
            onSaveFilter('Default');
          }
        }
      })
      .catch(err => {
        !cancelled && console.log(err);
      });

    return () => (cancelled = true);
    // eslint-disable-next-line
  }, [changeFilter]);

  useEffect(() => {
    if (triggerStartEffect) {
      if (typeof triggerSaveTableSettings === 'string') {
        onSaveFilter(triggerSaveTableSettings, undefined, false);
      } else {
        onSaveFilter(changeFilter, undefined, true);
      }
    }
    // eslint-disable-next-line
  }, [triggerSaveTableSettings]);

  useEffect(() => {
    setTriggerStartEffect(true);
    // eslint-disable-next-line
  }, []);

  const createFilterSettings = (
    filter,
    filterBackend,
    nameFilter,
    edit = false
  ) => {
    const keyDefault = [
      ...Object.keys(defaultFilters),
      ...Object.keys(defaultNavigation)
    ].sort();
    const keyfilter = Object.keys(filter).sort();

    let newFilterForBeckend = {
      ...filter
    };

    if (!isEqual(keyDefault, keyfilter)) {
      keyfilter.forEach(item => {
        if (keyDefault.includes(item)) {
          return;
        }
        newFilterForBeckend = { ...delProperties(newFilterForBeckend, [item]) };
      });
    }

    if (!edit) {
      const newListFilter = {
        key: filterBackend.key,
        value: [
          ...filterBackend.value,
          {
            name: nameFilter,
            filters: newFilterForBeckend,
            tableConf: tableConf
          }
        ]
      };
      return { forBack: newListFilter, forFilter: newFilterForBeckend };
    } else {
      const newListFilter = {
        key: filterBackend.key,
        value:
          filterBackend.value.length > 0
            ? filterBackend.value.map(filter => {
                if (filter.name !== changeFilter) {
                  return filter;
                } else {
                  return {
                    name: changeFilter,
                    filters: newFilterForBeckend,
                    tableConf: tableConf
                  };
                }
              })
            : [
                {
                  name: changeFilter,
                  filters: newFilterForBeckend,
                  tableConf: tableConf
                }
              ]
      };

      return { forBack: newListFilter, forFilter: newFilterForBeckend };
    }
  };

  const onSaveFilter = (nameFilter, resaveArr, edit = false) => {
    const linkForRequest = `/user/storage/write`;

    if (
      !filterBackend.value.find(filter => filter.name === nameFilter.trim()) ||
      edit
    ) {
      const REQ_BODY = createFilterSettings(
        filter,
        filterBackend,
        nameFilter.trim(),
        nameFilter !== changeFilter ? false : true
      );

      postRequest(linkForRequest, REQ_BODY.forBack)
        .then(() => {
          setChangeFilter(nameFilter);
          setVisibleFilterSave(false);
          setVisibleFilterEdit(false);
          setFilterBackend(REQ_BODY.forBack);
          if (nameFilter !== 'Default') {
            showNotif({
              message: `Filter settings saved`,
              kind: 'success',
              dismissAfter: 5000,
              type: 'alert'
            });
          }
          setFilter(REQ_BODY.forFilter);
        })
        .catch(err => {
          console.log(err);
        });
    } else if (resaveArr) {
      setFilterBackend({ ...filterBackend, value: resaveArr });
      postRequest(linkForRequest, { ...filterBackend, value: resaveArr })
        .then(() => {
          setVisibleFilterSave(false);
          setVisibleFilterEdit(false);
        })
        .catch(err => {
          console.log(err);
        });
    } else {
      showNotif({
        message: `this filter name has already been declared`,
        kind: 'error',
        dismissAfter: 5000,
        type: 'alert'
      });
    }
    if (setFilterButton) {
      setFilterButton(false);
    }
  };

  const onDellFilter = nameDellFilter => {
    const linkForRequest = `/user/storage/write`;
    const newFiltersList = {
      ...filterBackend,
      value: filterBackend.value.filter(
        filter => filter.name !== nameDellFilter
      )
    };
    postRequest(linkForRequest, newFiltersList)
      .then(() => {
        setFilterBackend(newFiltersList);
        if (nameDellFilter === changeFilter) {
          setFilter(
            newFiltersList.value.find(filter => filter.name === 'Default')
              .filters
          );
          setChangeFilter('Default');
          resetAllfilters();
          setVisibleFilterSave(false);
          setVisibleFilterEdit(false);
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  const handleChangeFilter = name => {
    if (name !== 'Default') {
      setChangeFilter(name);

      const filterSelectedFromBack = filterBackend.value.find(
        filter => filter.name === name
      ).filters;

      const tableFromBack = filterBackend.value.find(
        filter => filter.name === name
      ).tableConf;

      const keyDefault = [
        ...Object.keys(defaultFilters),
        ...Object.keys(defaultNavigation)
      ].sort();

      const keyfilterBackend = Object.keys(filterSelectedFromBack).sort();

      let updateFilter = {
        ...defaultFilters,
        ...filterSelectedFromBack
      };

      let showAlarm = false;
      if (!isEqual(keyDefault, keyfilterBackend)) {
        keyfilterBackend.forEach(el => {
          if (
            keyDefault.indexOf(el) === -1 &&
            !listChangedNameFilers[filterBackend.key].find(
              item => item.name === el
            )
          ) {
            if (
              Array.isArray(updateFilter[el]) &&
              updateFilter[el].length !== 0
            ) {
              showAlarm = true;
            }
          }
        });
      }

      if (tableFromBack && name !== 'Default') {
        let config = [];

        tableFromBack.forEach(item => {
          const forConfig = defaulTableConf.find(e => e.field === item.field);
          if (forConfig) {
            config.push({ ...forConfig, show: item.show });
          }
        });

        defaulTableConf.forEach(item => {
          const optionNotInSaveList = tableFromBack.find(
            e => e.field === item.field
          );
          if (!optionNotInSaveList) {
            config.push(item);
          }
        });

        setTableConf(config);
      } else {
        setTableConf(JSON.parse(JSON.stringify(defaulTableConf)));
      }

      if (showAlarm) {
        showNotif({
          message: `There were changes in filters, please re-save the filters`,
          kind: 'warning',
          dismissAfter: 5000,
          type: 'alert'
        });
      }

      setFilter({
        ...updateFilter,
        ...defaultNavigation
      });

      setVisibleFilterSave(false);
      setVisibleFilterEdit(false);
      setTrigerResetDatePicker(!trigerResetDatePicker);
      setStartFilter(!startFilter);
    } else {
      resetAllfilters(false, false, true);
    }
  };

  return (
    <div className={classes.saveFilterWrap}>
      {visibleFilterSave === 'button' && (
        <ButtonIcon
          icon="save"
          buttonText={t('activity:filters.SAVE_VIEW_AS')}
          onClick={() => {
            setVisibleFilterSave('input');
            setVisibleFilterEdit(false);
          }}
        />
      )}
      {visibleFilterEdit && (
        <ButtonIcon
          className={classes.save}
          icon="update"
          buttonText={t('activity:filters.SAVE_VIEW')}
          onClick={() => onSaveFilter(changeFilter, undefined, true)}
        />
      )}
      {visibleFilterSave === 'input' && (
        <InputWithEnter
          placeholder={t('activity:filters.ENTER_VIEW_NAME')}
          iconSearch={false}
          handleSubmit={onSaveFilter}
        />
      )}
      <div className={classes.changeFilterButtons}>
        <FiltersListButtons
          filterBackend={filterBackend}
          setChangeFilter={setChangeFilter}
          changeFilter={changeFilter}
          setFilter={setFilter}
          onDellFilter={onDellFilter}
          handleChangeFilter={handleChangeFilter}
          onSaveFilter={onSaveFilter}
        />
      </div>
    </div>
  );
};

SaveFilterBlock.propTypes = {
  filter: PropTypes.object,
  visibleFilterSave: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  setVisibleFilterSave: PropTypes.func,
  visibleFilterEdit: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  setVisibleFilterEdit: PropTypes.func,
  filterBackend: PropTypes.object,
  setFilterBackend: PropTypes.func,
  setFilter: PropTypes.func,
  changeFilter: PropTypes.string,
  setChangeFilter: PropTypes.func,
  resetAllfilters: PropTypes.func,
  defaultNavigation: PropTypes.object,
  trigerResetDatePicker: PropTypes.bool,
  setTrigerResetDatePicker: PropTypes.func,
  startFilter: PropTypes.bool,
  setStartFilter: PropTypes.func,
  defaultFilters: PropTypes.object,
  tableConf: PropTypes.array,
  setTableConf: PropTypes.func,
  defaulTableConf: PropTypes.array,
  triggerSaveTableSettings: PropTypes.bool,
  setFilterButton: PropTypes.func
};

export default SaveFilterBlock;
